import { finiteIntegerNumber, nonEmptyTrimmedStringFromUnknown } from "./shared.js";
import { profileSchema } from "./profile.js";
import { spaceAgentStreamDeltaFrameSchema, spaceAgentStreamPartFrameSchema, spaceAgentStreamTerminalFrameSchema } from "./agent-stream.js";
import { spaceThreadContextSchema, spaceThreadSignalPlacementSchema } from "../space-mesh/space-thread.js";
import { signalStatusDataSchema, signalSystemNoticeDataSchema, signalTextDataSchema } from "./signal.js";
import { spaceMessageReactionsSchema } from "../space-mesh/message-reaction.js";
import { helloAckSchema } from "./hello.js";
import { serverErrorFrameSchema } from "./server-error.js";
import * as z$1 from "zod/v4";
//#region src/schemas/protocol/envelope.ts
const baseEnvelopeShape = {
	v: z$1.literal(1),
	id: nonEmptyTrimmedStringFromUnknown,
	spaceId: nonEmptyTrimmedStringFromUnknown,
	ts: finiteIntegerNumber,
	profile: profileSchema
};
const presenceDataSchema = z$1.record(z$1.string(), z$1.unknown());
const presenceEnvelopeSchema = z$1.object({
	...baseEnvelopeShape,
	type: z$1.enum(["presence.join", "presence.quit"]),
	data: presenceDataSchema
});
const signalTextEnvelopeSchema = z$1.object({
	...baseEnvelopeShape,
	type: z$1.literal("signal.text"),
	data: signalTextDataSchema,
	reactions: spaceMessageReactionsSchema.optional()
});
const signalStatusEnvelopeSchema = z$1.object({
	...baseEnvelopeShape,
	type: z$1.literal("signal.status"),
	data: signalStatusDataSchema
});
const signalSystemNoticeEnvelopeSchema = z$1.object({
	...baseEnvelopeShape,
	type: z$1.literal("signal.system_notice"),
	data: signalSystemNoticeDataSchema
});
const signalEnvelopeSchema = z$1.union([
	presenceEnvelopeSchema,
	signalTextEnvelopeSchema,
	signalStatusEnvelopeSchema,
	signalSystemNoticeEnvelopeSchema
]);
const spaceLiveSignalFrameSchema = z$1.strictObject({
	type: z$1.literal("space.signal"),
	signal: signalEnvelopeSchema,
	history: z$1.strictObject({ persisted: z$1.boolean() }).optional(),
	threadContext: spaceThreadContextSchema.optional(),
	threadPlacement: spaceThreadSignalPlacementSchema.optional()
});
const spaceLiveInvalidationFrameSchema = z$1.strictObject({
	type: z$1.enum([
		"space.members.changed",
		"space.meta.changed",
		"space.files.changed",
		"space.tasks.changed",
		"space.reactions.changed",
		"agent.readiness.invalidated",
		"wake.progress.changed"
	]),
	spaceId: nonEmptyTrimmedStringFromUnknown,
	version: finiteIntegerNumber,
	signalIds: z$1.array(nonEmptyTrimmedStringFromUnknown).optional(),
	profileIds: z$1.array(nonEmptyTrimmedStringFromUnknown).optional(),
	agentProfileIds: z$1.array(nonEmptyTrimmedStringFromUnknown).optional(),
	clientMessageIds: z$1.array(nonEmptyTrimmedStringFromUnknown).optional(),
	reason: nonEmptyTrimmedStringFromUnknown.optional()
});
const incomingServerMessageSchema = z$1.union([
	signalEnvelopeSchema,
	spaceLiveSignalFrameSchema,
	spaceLiveInvalidationFrameSchema,
	spaceAgentStreamDeltaFrameSchema,
	spaceAgentStreamPartFrameSchema,
	spaceAgentStreamTerminalFrameSchema,
	helloAckSchema,
	serverErrorFrameSchema
]);
//#endregion
export { incomingServerMessageSchema, presenceEnvelopeSchema, signalEnvelopeSchema, signalStatusEnvelopeSchema, signalSystemNoticeEnvelopeSchema, signalTextEnvelopeSchema, spaceLiveInvalidationFrameSchema, spaceLiveSignalFrameSchema };

//# sourceMappingURL=envelope.js.map